import { VotingAbi } from "../config/abi/votingAbi";
import { CHAINS } from "../config/env";
import { getWalletAddress } from "../lib/localStorage";
import { CURRENT_CHAIN_ID, useWeb3 } from "./useWeb3";

export const getVotingAddress = () => {
    try {
        let CHAIN_ID = CURRENT_CHAIN_ID();
        console.log("CHAIN_ID", CHAIN_ID);
        let votingaddress = CHAINS.find(e => e?.CHAIN_ID == CHAIN_ID);
        console.log(votingaddress, 'votingaddress')
        return votingaddress?.VOTING;
    }
    catch(e){
        console.log("Error on get voting address" , e);
    }
}

export const UseVoting = async () => {
    const web3 = await useWeb3();
    const contract = new web3.eth.Contract(VotingAbi, getVotingAddress());
    return contract;
}

export const getPropsals = async () => {
    try {
        let contract = await UseVoting();
        console.log('contractcontract',contract)
        let result = await contract.methods.getAllProposals().call();
        console.log("result in proposal", result);
        return result;
    }
    catch (e) {
        console.log("Error on get proposals", e);
    }
}


export const getProposalslug = async () => {
    try {
        let contract = await UseVoting()
        let result = await contract.methods.proposalSlugs().call();
        return result;
    }
    catch (e) {
        console.log("Error on get proposal slug", e);

    }
}

export const getProposalBYslug = async (slug) => {
    try {
        let contract = await UseVoting()
        let result = await contract.methods.getProposalBySlug(slug).call();
        return result;
    }
    catch (e) {
        console.log("Error on get proposal slug", e);

    }
}

export const CreateVoting = async (data) => {
    const web3 = await useWeb3();
    const account = getWalletAddress()
    try {
        let { info, start, end, power } = data;
        console.log("Amt---data", info);
        let contract = await UseVoting()
        let result = await contract.methods.createProposal(info, start, end, power).send({ from: web3.utils.toChecksumAddress(account) });
        return { type: "success", data: "" };
    } catch (error) {
        console.log("Error on BuySellBYDcontract: ", error);
        return { type: "error", message: error.message }
    }
}


export const Voting = async (data) => {
    const web3 = await useWeb3();
    const account = getWalletAddress()
    try {
        let {type , pid} = data;
        console.log("Amt---data", data);
        let contract = await UseVoting()
        let result = await contract.methods.vote(type , pid).send({ from: web3.utils.toChecksumAddress(account) });
        return { type: "success", data: "" };
    } catch (error) {
        console.log("Error on BuySellBYDcontract: ", error);
        return { type: "error", message: error.message }
    }
}


export const ProposalApproval = async (data) => {
    const web3 = await useWeb3();
    const account = getWalletAddress()
    try {
        let { pid} = data;
        console.log("Amt---data", data);
        let contract = await UseVoting()
        let result = await contract.methods.approveProposal(pid).send({ from: web3.utils.toChecksumAddress(account) });
        return { type: "success", data: "" };
    } catch (error) {
        console.log("Error on BuySellBYDcontract: ", error);
        return { type: "error", message: error.message }
    }
}

export const FinalizeApproval = async (data) => {
    const web3 = await useWeb3();
    const account = getWalletAddress()
    try {
        let { pid} = data;
        console.log("Amt---data", data);
        let contract = await UseVoting()
        let result = await contract.methods.finaliseProposal(pid).send({ from: web3.utils.toChecksumAddress(account) });
        return { type: "success", data: "" };
    } catch (error) {
        console.log("Error on BuySellBYDcontract: ", error);
        return { type: "error", message: error.message }
    }
}





